<template>
	<div class="detail">
		<div v-if="selectType != 7">
			<div class="back">
				<img @click="backIndex" style="width: 10.5rem;height: 5.625rem;" src="http://img.static.knnnj.com/Default/3d2b259d-3f0f-4f1d-b21c-7fc746aece34.png" />
				<!-- <div class="buy" @click="showOrCode">立即购买</div> -->
			</div>
			<div style="margin-top: -0.25rem;" v-for="(item,i) in imageList" :key="i">
				<img style="width: 75rem;" :src="item" />
			</div>
		</div>
		<div  v-if="selectType == 7">
			<div style="position: absolute;" @click="backIndex">
				<img style="width: 10.5rem;height: 5.625rem;" src="http://img.static.knnnj.com/Default/3d2b259d-3f0f-4f1d-b21c-7fc746aece34.png" />
				<!-- <div class="buy" @click="showOrCode">立即购买</div> -->
			</div>
			<div>
				<img style="width: 100%;margin-top: -0.25rem;" src="http://img.static.knnnj.com/Default/bd70cd56-a8d9-46ba-a079-95814627b659.png"/>
				<img style="width: 100%;margin-top: -0.25rem;" src="http://img.static.knnnj.com/Default/33951c8c-7099-40a6-af0d-298a05bf036e.png"/>
				<img style="width: 100%;margin-top: -0.25rem;" src="http://img.static.knnnj.com/Default/cad40aeb-cad2-419b-809d-ce2ebb3f0130.png"/>
			</div>
			<div class="footer-app">
				<div class="footer-div-app address-app">
					<span>福建松辉医药有限公司惠安分公司</span>
					<span style="margin-left: 22.5625rem;">公司地址</span>
				</div>
				<div class="footer-div-app" style="margin-top: 0.625rem;">
					<div class="slogan-app">
						<span>诚信为本，心怀敬畏</span>
						<span>创新求变，行稳致远</span>
						<span>合作共赢，价值共享</span>
					</div>
					<div class="addressInfo-app">
						<span>福建省泉州市惠安县辋川镇后许村 后许422-8号店面</span>
					</div>
				</div>
				<div class="footer-div-app">
					<span class="tel-text-app">欢迎致电</span>
					<span class="tel-number-app">0595-87819781</span>
				</div>
				<div class="registration-app">
					<span>网站备案号：闽ICP备2021000831号-1</span>
				</div>
			</div>
		</div>
		<el-dialog
		  :visible.sync="isShowOrCode"
		  width="25%"
		  :before-close="handleClose">
		  <div class="iamge">
			  <img :src="orCord.image" class="img"/>
		  </div>
		  <div class="orCord">
			  <div class="name">{{ orCord.name }}</div>
			  <div class="price">￥{{ orCord.price }}</div>
			  <div style="font-size: 1rem; color: #999999;">打开微信扫一扫进行购买</div>
		  </div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		props: {
		      selectType: Number,
		      required: true
		},
	    data() {
	        return {
				imageList: [],
		        bgImg: [
					'http://img.static.knnnj.com/Default/b55d6677-5ba2-47ba-8e05-eb310be38407.png',
					'http://img.static.knnnj.com/Default/ca55cea5-81d6-413e-bba6-5a1fe3b1788c.png',
					'http://img.static.knnnj.com/Default/468cbcde-7193-47ca-b2b0-03e7d8186ae2.png',
					'http://img.static.knnnj.com/Default/a117e8cf-c957-496f-a2dc-6b49854ba48d.png',
					'http://img.static.knnnj.com/Default/5360976c-1a36-4f82-9260-f0009dd8d798.png',
					'http://img.static.knnnj.com/Default/cbd2412a-7de3-4bfd-80be-b3d73ee8f34b.png',
				],
				trainThreeImg: [
					'http://img.static.knnnj.com/Default/d184f1eb-1d56-4ce2-9336-12cc7bddce17.png',
					'http://img.static.knnnj.com/Default/8575363e-3559-4f1a-b0a7-e352d97bffb9.png',
					'http://img.static.knnnj.com/Default/a8b7d8b1-2ddb-43a6-a99e-35bfb3dd9b35.png',
					'http://img.static.knnnj.com/Default/79fc9570-52d6-4577-a466-ce1c491fba5a.png',
					'http://img.static.knnnj.com/Default/1ddd5cd6-6d9c-43ab-97e9-55006d924db7.png',
					'http://img.static.knnnj.com/Default/c17fa9e6-63de-45b8-b7cc-7b93e76297d8.png',
					'http://img.static.knnnj.com/Default/f04ba8a5-6d07-4a95-9794-6594eb8366de.png',
				],
				activityImg: [
					'http://img.static.knnnj.com/Default/b6cbe4f1-83d1-4568-a5cd-be89b80b4954.png',
					'http://img.static.knnnj.com/Default/703f9b0a-70a7-4fab-ad30-431a72c2b731.png',
					'http://img.static.knnnj.com/Default/feb1ac64-3772-4e23-b54f-bd4fcb01dac9.png',
					'http://img.static.knnnj.com/Default/5c527598-7743-4226-9d5b-c15f0a36b690.png',
					'http://img.static.knnnj.com/Default/5b25beb6-47ec-4e9b-b172-ab201e2c89db.png',
					'http://img.static.knnnj.com/Default/c8bfe95b-bd37-420c-a3a9-1b491e304e54.png',
					'http://img.static.knnnj.com/Default/092d74dc-44a2-4533-a522-ceecd05b8fe6.png',
					'http://img.static.knnnj.com/Default/55850d49-a2b1-4bdf-91a0-79e50c6e38af.png',
					'http://img.static.knnnj.com/Default/7435c7ed-f817-44b4-9c16-d6f6d95ad8de.png',
					'http://img.static.knnnj.com/Default/0b6174cf-4132-4b47-b8bb-78d40a36c202.png',
				],
				forumImg: [
					'http://img.static.knnnj.com/Default/4b5cccc7-22ac-4749-8ddb-95be586d7239.png',
					'http://img.static.knnnj.com/Default/bc1ec4a4-5c24-42a7-92fb-d2ee8477c888.png',
					'http://img.static.knnnj.com/Default/0a54677b-59e4-49c2-b034-eade8ffcbae8.png',
					'http://img.static.knnnj.com/Default/b227ee4c-3fad-4a9b-95e6-511b25dd6a45.png',
					'http://img.static.knnnj.com/Default/5a6e5e98-f7ae-42c3-b1e3-2d0d91d9f81d.png',
					'http://img.static.knnnj.com/Default/cfb19524-a2a9-4503-8db4-8fa857b82dcf.png',
					'http://img.static.knnnj.com/Default/22db46ec-6d92-49be-a585-7fc1ac33bfc4.png',
					'http://img.static.knnnj.com/Default/6c513219-c71e-465c-8ea1-fc1f1ab57e1b.png',
					'http://img.static.knnnj.com/Default/920ef580-9359-48a0-a957-f84edf18e618.png',
				],
				trainImg: [
                    'http://img.static.knnnj.com/Default/3fbd4f6a-ad40-4846-913a-5134d211a1c6.png',
                    'http://img.static.knnnj.com/Default/cc3bcdbc-ae15-48bc-bbaf-0f8e2c4927f3.png',
                    'http://img.static.knnnj.com/Default/08532d45-1fc0-42b6-8187-c5c47c97afad.png',
                    'http://img.static.knnnj.com/Default/f98788b4-6229-4339-bb9e-7f20c33f2b77.png',
                    'http://img.static.knnnj.com/Default/444990c0-9f9c-41e6-92ac-21dee8520ba5.png',
                    'http://img.static.knnnj.com/Default/fd86f7a3-6b80-4789-aeb2-17dee9d0acd8.png',
				],
				introduceImg: [
					'http://img.static.knnnj.com/Default/e7b4edc8-cd8c-4403-aadd-68cbb2565a65.png',
					'http://img.static.knnnj.com/Default/58bc3104-1350-49d7-80e4-a8e5eefbc501.png',
					'http://img.static.knnnj.com/Default/a5f1d466-509a-43e2-a1e2-546255f51905.png',
					'http://img.static.knnnj.com/Default/88c7149b-98c8-47ac-9a11-16b13f859f70.png',
					'http://img.static.knnnj.com/Default/fc6dd46f-4eef-40cb-bb8b-246175c2fc45.png',
					'http://img.static.knnnj.com/Default/6fdfb2f6-ea84-49f6-b321-0428f8f52240.png',
				],
				isShowOrCode: false,
				orCord: {
				},
				orCords: [
					{
						name:'熊胆胶囊',
						price: 3998.00,
						image: 'http://img.static.knnnj.com/Default/c32ab21e-ade2-45c9-81e8-79a2d501c6ec.jpeg',
						isShowOrCode: false
					},
					{
						name:'熊胆胶囊',
						price: 3998.00,
						image: 'http://img.static.knnnj.com/Default/c32ab21e-ade2-45c9-81e8-79a2d501c6ec.jpeg',
						isShowOrCode: false
					},
					{
						name:'与归真堂',
						price: 3998.00,
						isShowOrCode: false,
						image: 'http://img.static.knnnj.com/Default/b68a3cd3-cd50-404d-8018-65418755dc5f.jpeg'
					},
					{
						name:'熊胆粉',
						price: 3998.00,
						isShowOrCode: false,
						image: 'http://img.static.knnnj.com/Default/69775ab3-d3fc-436f-83a6-9d5dc15cb17b.jpeg'
					}
				]
			}
	    },
		watch: {
			selectType: function(a,b){     //a是value的新值，b是旧值
			    this.selectIndex(a);
		    }
		},
		created() {
			this.selectIndex()
			//this.orCord = this.orCords[this.index]
		},
		methods:{
			selectIndex(value) {
				if(this.selectType == 2) {
					this.imageList = this.trainThreeImg
				} else if(this.selectType == 3) {
					this.imageList = this.activityImg
				} else if(this.selectType == 4) {
					this.imageList = this.forumImg
				} else if(this.selectType == 5) {
					this.imageList = this.trainImg
				} else if(this.selectType == 6) {
					this.imageList = this.introduceImg
				} else {
					this.imageList = this.bgImg
				}
			},
			backIndex() {
				this.selectType = 0
				this.imageList = []
                this.$parent.backIndex();
			},
			// 控制二维码的展示
			showOrCode(){
				this.isShowOrCode = true
			},
			// 控制弹窗的关闭
			handleClose(){
				this.isShowOrCode = false
			}
		}
	}
</script>

<style>
	body {
		margin: 0;
		text-align: center;
	}
	
	.detail {
		width: 100%;
		justify-content: center;
	}
	
	.back {
		position: fixed;
		top: 3.75rem;
		left: 4rem;
	}
	
	.footer-app {
		width: 120rem;
		height: 17.5rem;
		background-color: #EFC16C;
	}
	
	.footer-div-app {
		margin-left: 29.125rem;
		font-family: PingFangSC-Medium, PingFang SC;
		color: #FFFFFF;
		display: flex;
	}
	
	.address-app {
		padding-top: 1.25rem;
		height: 2.5rem;
		font-size: 1.75rem;
		font-weight: 500;
		line-height: 2.5rem;
	}
	
	.slogan-app {
		width: 10rem;
		height: 1.5rem;
		font-size: 1.0625rem;
		font-weight: 500;
		line-height: 1.5rem;
	}
	
	.addressInfo-app {
		width: 16.5rem;
		height: 4.5rem;
		font-size: 1.0625rem;
		font-weight: 500;
		line-height: 1.5rem;
		margin-left: 38.875rem;
	}
	
	.tel-text-app {
		width: 6.125rem;
		height: 2.3125rem;
		font-size: 1.25rem;
		font-weight: 500;
		line-height: 2.3125rem;
		margin-top: 0.625rem;
	}
	
	.tel-number-app {
		width: 12.5rem;
		height: 2.3125rem;
		font-size: 1.625rem;
		font-weight: 500;
		line-height: 2.3125rem;
		margin-top: 0.625rem;
	}
	
	.registration-app {
		display: flex;
		justify-content: center;
		font-size: 1.375rem;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: #FFFFFF;
		margin-top: 1.875rem;
	}
	.buy{
		margin: auto;
		margin-top: 1.25rem;
		width: 7.375rem;
		height: 2.5rem;
		border-radius: 1.25rem;
		background-color: rgb(255,237,237);
		border: 1px solid #ff0000;
		color: rgb(255,96,96);
		line-height: 40px;
		text-align: center;
		font-size:20px ;
		font-weight: 800;
	}
	.el-dialog{
		border: .625rem;
		height: 32.5rem;
		border-radius: 10px;
	}
	.el-dialog__body{
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		width: 92%;
		height: 85%;
	}
	.orCord{
		margin-top: 20px;
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
	.iamge{
		width: 320px;
		height: 330px;
	}
	.img{
		width: 100%;
	}
	.name{
		font-size: 1.5rem;
		color: #333333;
	}
	.price{
		font-size: 1.5rem;
		color: #333333;
		font-weight: bolder;
	}
</style>



// WEBPACK FOOTER //
// src/views/detail.vue